import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import useRouter from 'utils/useRouter'
import { refreshNotifications } from 'redux/actions'

// Example of user roles: ['GUEST', 'USER', 'ADMIN'];

const AuthGuard = props => {
  const { children } = props
  const dispatch = useDispatch()
  const loggedIn = useSelector(state => state.session.loggedIn)
  const lastRefresh = useSelector(state => state.unsaved.lastRefresh)
  const router = useRouter()
  useEffect(() => {
    if (!loggedIn) {
      if (
        router.pathname !== '/' &&
        router.pathname !== '/signin' &&
        router.pathname !== '/signup'
      )
        router.push('/signin')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, loggedIn])

  useEffect(() => {
    const date = new Date()
    if (lastRefresh && date - lastRefresh > 2 * 60 * 1000) {
      dispatch(refreshNotifications())
    }
    // eslint-disable-next-line
  }, [router, lastRefresh])
  return <Fragment>{children}</Fragment>
}

AuthGuard.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.array.isRequired
}

AuthGuard.defaultProps = {
  roles: []
}

export default AuthGuard
